export default __webpack_public_path__ + "static/media/ExitOn.d7a9faaa.png";